import { SET_LAYOUT } from '../actions/types';

export default function setLayout(state = {}, action) {
	if (!action.error && action.payload) {
		if (action.type === SET_LAYOUT) {
			const {
				payload: { layout, allowLayoutToggle }
			} = action;
			return {
				...state,
				layout,
				allowLayoutToggle:
					allowLayoutToggle !== undefined
						? allowLayoutToggle
						: state.allowLayoutToggle
			};
		}
	}

	return state;
}
